@let menuItem = item();
@if (helper.isExternalLinkItem(menuItem)) {
    <a class="link" [href]="menuItem.link" target="_blank" rel="noopener noreferrer">
        <onego-menu-title-icon [item]="menuItem" />
    </a>
} @else if (helper.isRouterLinkItem(menuItem)) {
    <a
        class="link"
        [class]="{ active: rla.isActive }"
        aria-current="page"
        [routerLink]="menuItem.link"
        routerLinkActive
        [routerLinkActiveOptions]="{ exact: true }"
        (click)="toggleNavbar()($event, index(), false)"
        (touchstart)="toggleNavbar()($event, index(), false)"
        #rla="routerLinkActive"
    >
        <onego-menu-title-icon [item]="menuItem" />
    </a>
} @else if (helper.isActionItem(menuItem)) {
    <a class="link" [class.active]="menuItem.active" (click)="menuItem.action()" (touchstart)="menuItem.action()">
        <onego-menu-title-icon [item]="menuItem" />
    </a>
}
